import { actionCreatorFactory } from 'typescript-fsa';

export namespace ControllerSymbolLpAction {
  const actionCreator = actionCreatorFactory('ControllerSymbolLp');

  export const destroy = actionCreator('DESTROY');
}
